/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2021 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


 import React, { Component } from "react";
import RenderChart from '../charts/RenderChart'
import groupStyle from './groupTarget.scss';
import { convertToColumnForamat  } from '../../common/utils';
import EdwSwitchButton from '../common/edwSwitchButton/EdwSwitchButton';
import style from '../../styles.module.scss';
import groupConfig from '../../common/widgetConfigs/groupTarget'
import gridconfig from '../../common/tableConfig/gridConfig'
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import asyncCallHandler from '../../common/utils/asyncCallHandler'
import EDW_CONST from '../../common/constants';
import tableStyle from '../../component/common/style/index.scss';
import { EdwLoaderWithContainer } from '../common/edwLoaderWithContainer/EdwLoaderWithContainer';
import { ErrorData,BaselineTargetNoData,EmptyData } from "../common/noData/NoData";
import { EdwTooltip} from '../common/ToolTip/EdwTooltip'
import { EDWDropDown } from "../common/dropDown/DropDown";
export class GroupsTarget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            chartConfig: groupConfig.chartConfig,
            isDataLoaded: false,
            showChart: true,
            sortValue: 'asc',
            TargetData: [],
            coloumnDef: groupConfig.tableColumnDefinition,
            rowData: [],
            tableIcons: gridconfig.icons,
            isDataFetch: false,
            groupCourse: [],
            legendsClass: groupConfig.legendsClass,
            groupId: [],
            compareTags: [],
            isApiFail: false,
            selectedGroup: []
        }
        this.iesToken = props.token ? props.token : ''
    }

    componentDidMount() {
        let groupIds=[]
        groupIds.push(this.props.groupId);
        this.fetchGroupTarget(groupIds);
        this.fetchGroups();
    }
    fetchGroupTarget(groupIds) {

        let { schoolId, courseId } = this.props;
        let groupId = groupIds.join(',')
        this.setState({ isDataFetch: false, groupId: groupIds})
        asyncCallHandler(EDW_CONST.GROUP_END_POINT, `getGroupDetailsChart?courseId=${courseId}&groupId=${groupId}&schoolId=${schoolId}`, this.iesToken).then(response => {           
            this.getChartProps(response.data);            
        }).catch((error) => {
            this.setState({ TargetData: [], isApiFail:true });
            console.log("axios error:", error);
        });
    }
    fetchGroups() {
        let { schoolId, courseId } = this.props;
        asyncCallHandler(EDW_CONST.COMMON_END_POINT, `getGroupsByCourse?schoolId=${schoolId}&courseId=${courseId}&assessmentId=&academicYear=`, this.iesToken).then(response => {
            this.setState({ groupCourse: response.data })
        }).catch((error) => {
            this.setState({ groupCourse: [] });
            console.log("axios error:", error);
        });
    }

    componentDidUpdate(prevProps, prevState) {
        
        if (
            this.props.groupId !== prevProps.groupId ||
            this.props.studentYear !== prevProps.studentYear ||  this.props.courseId !== prevProps.courseId
        ) {
            let groupIds =[];
            groupIds.push(this.props.groupId);
            this.fetchGroupTarget(groupIds);
        }
        this.props.updateExportData({ type: "group_widget_1", rowData: this.state.rowData, columnDefs: this.state.coloumnDef });
    }

    getChartProps = (TargetData) => {
        let chartData = convertToColumnForamat(TargetData);
        let chartConfigs = Object.assign({}, this.state.chartConfig);
       //let { width, height } = this.props;
         let width = 200 + (parseInt(chartData.dataset.length) * 70);
         chartConfigs.width = (width <= 1000) ? width : 1000;
        chartConfigs.height = '350';
        chartConfigs.dataSource.chart.plotSpacePercent = (chartData.dataset.length <= 1) ? "83" :"60";
        chartConfigs.dataSource.trendlines =[];
        if(chartData.dataset.length > 1){
            chartConfigs.dataSource.trendlines= [
                {
                    "line": [
                        {
                            "color": "#820068",
                            "thickness": "2",
                            "startvalue": chartData.average,
                            "valueOnRight": "1",
                            "displayvalue": "average " + chartData.average+"%"
                        }
                    ]
                }
            ]
        }

        chartConfigs.dataSource.chart.xAxisName = this.props.xAxisName ? this.props.xAxisName : "Group/course"
        chartConfigs.dataSource.chart.yAxisName = this.props.yAxisName ? this.props.yAxisName : "Percentage of students"
        chartConfigs.dataSource.data= chartData.dataset; 
        
        this.setState({ rowData: TargetData, chartConfig: chartConfigs, isDataFetch: true, TargetData: TargetData })
        this.props.updateExportData({ type: "group_widget_1", rowData: TargetData,columnDefs:this.state.coloumnDef});
        //return chartConfigs;
    }
    switchView = (e) => {
        this.setState({ showChart: e.target.checked })
        let chartConfigs = Object.assign({}, this.state.chartConfig);
        if (e.target.checked) {
            // chartConfigs = this.getChartProps(this.state.TargetData);
        }
        this.setState({ chartConfig: chartConfigs });
    }
    getTableView = () => {
        return <div className="ag-theme-alpine" style={{
            height: '500px', width: '920px', margin: '0 auto', padding: '0px',
            position: 'relative'
        }} >
            <AgGridReact tooltipShowDelay={0}
                columnDefs={this.state.coloumnDef}
                rowData={this.state.rowData}
                icons={this.state.tableIcons}
                onSortChanged={this.onSortChanged.bind(this)}
            />

        </div>
    }
    sort_by_key = (array, key) => {
        return array.sort(function (a, b) {
            var x = a[key]; var y = b[key];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
    }
    onSortChanged = (params) => {
        let sortModel = params.api.getSortModel();
        let sortedRowData = this.sort_by_key(this.state.rowData, sortModel[0]["colId"]);
        this.setState({ rowData: sortedRowData });
    }
 
    compareChart = (e) => {

        let groupIds = [... this.state.groupId]
        let compareTags = [... this.state.compareTags];
        let selectedGroup = [...this.state.selectedGroup];
        compareTags = [];
        selectedGroup = [];
        groupIds.splice(1);
        if (e.length > 0) {
            e.map((val) => {
                if (val != "") {
                    let selectedOption = val.split("/");
                    let index = groupIds.indexOf(selectedOption[0]);
                    if (index == -1) {
                        selectedGroup.push(val)
                        groupIds.push(selectedOption[0]);
                        compareTags.push({ key: selectedOption[1], value: selectedOption[0] })
                    }
                }
            })
        }
             
        this.props.isCompare(groupIds)
        this.setState({ groupId: groupIds, compareTags: compareTags, selectedGroup: selectedGroup })
        this.fetchGroupTarget(groupIds);

        // let groupIds = [... this.state.groupId]
        // if (groupIds.length < 2) {
        //     groupIds.push(e.target.value);
        //     let compareTags = [... this.state.compareTags];
        //     compareTags.push({ key: optionKey, value: e.target.value });

        //     this.setState({ groupId: groupIds, compareTags: compareTags })
        //     this.fetchGroupTarget(groupIds);
        // }
    }
    dropDownView(options) {

        return (
            <EDWDropDown
                items={options.filter(
                    id => id.id !== this.props.groupId
                ).map(val => {
                    return {
                        id: val.id + '/' + val.label, label: val.label
                    }
                })}
                onChange={this.compareChart}
                label="Select Group/course"
                multiple
                selectAllActive='false'
                value={this.state.selectedGroup.filter(id => id)}
            />
        )
    }
   
  
    getChartBlock = () => { 
        if (!this.state.isDataFetch && !this.state.isApiFail)
            return <EdwLoaderWithContainer />
        else if (this.state.isDataFetch && this.state.TargetData.length > 0 && !this.state.isApiFail) {
                return <div className="chartCls">
                    <RenderChart chartConfigs={this.state.chartConfig} fusionKey={this.props.fusionKey}/>
                </div>
        }
        else if (this.state.isDataFetch && this.state.TargetData.length == 0 && !this.state.isApiFail) {
            return <EmptyData message={EDW_CONST.STU_BELOW_EMPTY_MSG} />
        }
        else{
             return <ErrorData />
        } 
    }


    render() {
        let switchProps = {
            leftLable: EDW_CONST.TABLE_VIEW,
            rightLable: EDW_CONST.GRAPH_VIEW,
            checked: this.state.showChart,
            handleChange: this.switchView
        }
        return (
            < div >
                <div className="col">
                    <div className="row">
                        <div className="col-md-8 chartTitle">
                            <label><span className="card-title">Number of students on track to meet targets
                                 <EdwTooltip title="The last assessment result indicates the student is ‘on or above’ track to meet their course target. Based on linear progress from baseline to course target (excluding unit tests)." >
                                </EdwTooltip>
                                </span></label>
                        </div>
                    </div>
                    {(this.state.isDataFetch && this.state.TargetData.length > 0) && 
                    <div className="row content-row-padding" style={{ gap: 20, paddingRight: 9 }}>
                        <div style={{ flexGrow: 1 }}></div>
                        <div style={{ width: 320 }}>
                            <label className={style.lblColor}>Compare with</label>

                            {this.dropDownView(this.state.groupCourse)}

                        </div> 
                        <div>
                            <div className="edw-switch-btn-adj">
                                <EdwSwitchButton {...switchProps} />
                            </div>
                        </div>  
                    </div>
                    }
                 
                    <div className="row">
                        {this.state.showChart && <div className="edw-full-width">
                            {this.props.groupBaselineExist ? this.getChartBlock() : <BaselineTargetNoData/>}
                        </div>
                        }
                        {!this.state.showChart && <div className="center-align">
                            {this.state.isDataFetch ? (this.getTableView()) : ''}
                        </div>
                        }
                    </div>

                </div>
            </div>

        );
    }
}


